<template>
    <v-hover v-slot="{ hover }" open-delay="200">
        <v-flex xs12>
            <v-card
                flat
                rounded
                style="border-style: solid; border-width: 1px; border-color: lightgray; margin: 4px"
            >

                <v-card-title primary-title>
                    <crm-reminder-entry-menu
                        v-show="hover"
                        v-model="menuOpen"
                        :reminder="reminder"
                    />

                    <div style="width: 100%">

                    <menu-site-card
                        :sites="reminder.incident.sites"
                        :time="reminder.time"
                        :customer="null"
                        icon="fas fa-bell"
                        @expand="onExpand"
                    />

                    <div class="crm-reminder-primary-info">
                        <div class="w-100">
                            <div>{{ reminder.subject }}</div>
                            <div style="margin-top: -6px; white-space: pre-line">{{ reminder.description }}</div>
                        </div>

                        <div v-if="reminder.partner">
                            <div><p >{{ reminder.partner.name }}</p></div>
                            <div class="space-between" style="margin-top: -5px">
                                <div><p>{{ reminder.partner.phone }}</p></div>
                                <div><p>{{ reminder.partner.email }}</p></div>
                            </div>
                        </div>
                    </div>
                    </div>
                </v-card-title>
            </v-card>
        </v-flex>
    </v-hover>
</template>

<script>
import MenuSiteCard from "@/modules/crm/components/nav/MenuSiteCard";
import CrmReminderEntryMenu from "@/modules/crm/components/nav/CrmReminderEntryMenu";

export default {
    name: "CrmReminderEntry",
    props: [ "value", "reminder" ],

    components: {
        CrmReminderEntryMenu,
        MenuSiteCard
    },

    data: () => ({
        expand: false,
        menuOpen: false,
        fab: false,
    }),

    methods: {
        onExpand (value) {
            this.expand = value;
        },
    }
}
</script>

<style scoped>

.crm-reminder-buttons {
    position: absolute;
    width: 20px;
    display: block;
    right: 25px;
    top: 5px;
}


.crm-reminder-info p {
    margin-bottom: 0;
}

.v-application .headline, .v-application .title {
    line-height: 25px;
    font-size: 11pt!important;
    width: 370px;
}

::v-deep .v-card__title {
    align-items: center;
    display: flex;
    flex-wrap: wrap;
    font-size: 11pt;
    font-weight: 500;
    letter-spacing: .0125em;
    line-height: 25px;
    word-break: break-all;
    margin-bottom: 0;
    padding: 10px;
}

.crm-reminder-primary-info {
    font-size: 10pt;
    font-weight: 400;
    width: 100%;
}

.crm-reminder-primary-info p {
    font-weight: normal!important;
    margin-top: 0;
    margin-bottom: 0;
}

</style>